export const POST = 'POST';
export const SE_LIGA = 'SE_LIGA';
export const TERMO_DE_ACEITO = 'TERMO_DE_ACEITO';
